
















































import { Component, Vue, Prop, Emit, Watch, Ref } from 'vue-property-decorator';
import DataGrid from '@/components/DataGrid.vue';
import PivotGrid from '@/components/PivotGrid.vue';
import { DxColumn } from 'devextreme-vue/data-grid';
import { BModal } from 'bootstrap-vue';

@Component({
  components: {
    DataGrid,
    PivotGrid,
    DxColumn
  }
})
export default class EntityListPage extends Vue {
  @Prop({
      required: true
  }) public entityName!: string

  @Prop({
      required: true
  }) public allowAdd!: boolean;

  @Prop({
    required: false,
    default: false
  }) public allowFilters!: boolean;

  @Prop({
    required: true
  }) public allowEdit!: boolean;

  @Prop({
      required: true
  }) public pageTitle!: string;

  @Prop({
    required: false,
    default: 'datagrid'
  }) public renderer!: string;

  /**
   * Contiene i filtri.
   */
  public filters = {};
  public filtersChanged = false;

  // Riferimento al component PivotGrid.
  @Ref('PivotGridComponent')
  public PivotGridComponent!: PivotGrid;
  // Riferimento al component DataGrid.
  @Ref('DataGridComponent')
  public DataGridComponent!: DataGrid;
  // Riferimento alla modale.
  @Ref('list-filters-modal')
  public FiltersModalComponent!: BModal;

  @Watch('filters', {
    deep: true
  })
  public onFiltersChange(currentValue: any, oldValue: any) {
    this.filtersChanged = true;
  }

  public get isDataGrid(): boolean {
    return this.renderer === 'datagrid';
  }

  public get isPivotGrid(): boolean {
    return this.renderer === 'pivotgrid';
  }

  // Effettua il refresh del datasource del componente.
  public refreshDatasource(): void {
    if (this.PivotGridComponent) this.PivotGridComponent.fetchData();
    if (this.DataGridComponent) this.DataGridComponent.fetchData();
  }

  constructor() {
    super();
  }

  @Emit("onItemSelected")
  public onItemSelected($event: any) {
    //console.info('-> onItemSelected on EntityListPage invoked.');
  }

  public onEditButtonClicked($event: any) {
    this.navigateToEdit($event);
  }

  public onRowDoubleClick($event: any) {
    if (this.allowEdit) {
      this.navigateToEdit($event);
    }
  }

  private navigateToEdit($event: any) {
    this.$router.push({
      path: `${this.entityName}/edit/${$event.id}`
    });
  }

  public spawnFilters(): void {
    this.FiltersModalComponent.show();
  }

  public triggerApplyFilterModalClose(): void {
    this.FiltersModalComponent.hide();
    this.refreshDatasource();
  }

  public entityNew() {
    this.$router.push({
      path: `${this.entityName}/edit/new`
    });
  }
}
